module.exports = __webpack_public_path__ + "img/compare1.a73792bd.png";